import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "@/i18n/en";
import ar from "@/i18n/ar";

Vue.use(VueI18n);

function loadLocaleMessages() {
  return {
    en: en,
    ar: ar,
  };
}

// export default new VueI18n({
//   locale: process.env.VUE_APP_I18N_LOCALE || 'en',
//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
//   messages: loadLocaleMessages()
// })

const vueI18n = new VueI18n({
  locale:
    localStorage.getItem("language") || process.env.VUE_APP_I18N_LOCALE || "ar",
  fallbackLocale:
    localStorage.getItem("language") ||
    process.env.VUE_APP_I18N_FALLBACK_LOCALE ||
    "ar",
  messages: loadLocaleMessages(),
});

export default vueI18n;

export function i18n(key, ...args) {
  return vueI18n.t(key, args);
}

// export default new VueI18n({
//   locale: process.env.VUE_APP_I18N_LOCALE || 'en',
//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
//   messages: loadLocaleMessages()
// })
